import { giveawayEndpointIds, } from 'root/src/shared/giveaways/giveaways.constants';
export const sendChatGiveawayLinkEndpoint = {
    [giveawayEndpointIds.SEND_CHAT_GIVEAWAY_LINK]: {
        isInternal: true,
        payloadSchema: {
            type: 'object',
            properties: {
                userId: { type: 'string' },
            },
            required: ['userId'],
        },
    },
};
